import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { NovaAmortizacaoAntecipada, NovasLiberacoesParaOperacao, OperacaoCreditoLivre } from 'src/app/model/operacao-credito-livre.model';

@Injectable({
    providedIn: 'root'
})
export class AmortizacaoAntecipadaService extends FgiBackEndService<NovaAmortizacaoAntecipada> {

    // @Override
    getNewEntity() {
        return new NovaAmortizacaoAntecipada();
    }

    // @Override
    protected getResourceURL(): string {
        return 'front/credito-livre/operacoes/amortizacoes';
    }

    enviarAmortizacoes(amortizacao: NovaAmortizacaoAntecipada, apenasValidar: boolean): Observable<Array<OperacaoCreditoLivre>> {
        console.debug('enviando novas amortizacoes ' + JSON.stringify(amortizacao));
        console.debug('apenas validar:' + apenasValidar);

        const options: any = blockUi();
        options.params.apenasValidacao = apenasValidar;

        return this.http.post(`${this.BASE_URL}`, amortizacao, options).pipe(
                catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
    }

    cancelarAmortizacao(idOperacao: number, idAmortizacaoAntecipada: number): Observable<OperacaoCreditoLivre> {
        const options: any = blockUi();

        return this.http.post(`${this.BASE_URL}/cancelar?idOperacaoCreditoLivre=${idOperacao}&idAmortizacao=${idAmortizacaoAntecipada}`, {}, options)
            .pipe(catchError((e) => this.handleError(e))) as Observable<OperacaoCreditoLivre>;

    }

}
